<template>
  <v-row>
    <v-col cols="12">
      <gg-card-title class="pb-0 pt-0">
        Service Alerts
      </gg-card-title>
    </v-col>
    <v-col cols="12">
      <alerts-table :alerts="items"/>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import AlertsTable from '@/components/Alerts/AlertsTable'

export default {
  name: 'AlertsView',
  components: {
    AlertsTable
  },
  computed: {
    ...mapGetters(['alerts', 'services']),
    items () {
      let arr = []

      this.alerts.forEach(item => {
        const service = this.services.find(service => service.id === item.serviceID)
        arr.push({
          id: item.id,
          serviceID: item.serviceID,
          alert_title: item.alert_title,
          alert_description: item.alert_description,
          status: item.status,
          currentUsage: item.currentUsage,
          alertThreshold: item.alertThreshold,
          created_at: item.created_at,
          last_notified_at: item.last_notified_at,
          updated_at: item.updated_at,
          service: `${service.name} - ${service.domain}`,
          subaccount_username: item.subaccount_username
        })
      })

      return arr
    }
  }
}
</script>

<style scoped>

</style>
